module.exports = __webpack_public_path__ + "img/arrow-right-gray-icon.1fe71373.svg";